import React from 'react'
import styled, { css } from 'styled-components'
import Container from './Container'
import ImageCopy from './ImageCopy'
import Section from './Section'
import media from 'css-in-js-media'
import { StyledHeading } from './Heading'

const X2ImageCopyWrap = styled(Section)`
    ${media('>=desktop')} {
        display: flex;
    }
    ${Container} {
        ${media('<desktop')} {
            padding-right: 0;
            padding-left: 0;
        }
    }

    + ${StyledHeading} {
        ${media('<desktop')} {
            padding-top: 40px;
        }
    }
`

const ImageCopyWrap = styled.div`
    ${media('>=desktop')} {
        width: 50%;
        margin: 0 8px;
    }

    :first-child {
        ${media('>=desktop')} {
            margin-left: 0;
        }
    }
    :last-child {
        ${media('>=desktop')} {
            margin-right: 0;
        }
    }
`

const X2ImageCopy: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <>
            {data.imageCopy && (
                <X2ImageCopyWrap>
                    <Container>
                        {data.imageCopy.map((imageCopyData, i) => {
                            imageCopyData['layout'] = 3
                            return (
                                <ImageCopyWrap key={i}>
                                    <ImageCopy data={imageCopyData} />
                                </ImageCopyWrap>
                            )
                        })}
                    </Container>
                </X2ImageCopyWrap>
            )}
        </>
    )
}

export default X2ImageCopy
